export default __webpack_public_path__ + "static/media/store.c2a3aad5.jpg";